export default "__VITE_ASSET__lU8heIba__"